<template>
  <div>
    <div class="noty"><i class="el-icon-warning"></i> Демо-режим, api не работает</div>

    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Типы процедур</span>
        <el-button class="box-header__button" size="mini" @click="addItem" type="primary">Добавить</el-button>
      </div>

      <template>
        <el-table :data="tableData" class="table">
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column  label="Тип">
            <template slot-scope="scope">
              <el-link type="primary" @click="editItem(scope.row.id)">
                {{
                  scope.row.title
                }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" width="140" label="Действия">
            <template slot-scope="scope">
              <el-tooltip content="Редактировать" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  @click="editItem(scope.row.id, scope.row)"
                />
              </el-tooltip>
              <el-tooltip content="Удалить" placement="top">
                <el-popconfirm
                  class="confirmBtn"
                  @onConfirm="deleteItem(scope.row.id, scope.$index)"
                  title="Вы уверены?"
                  confirmButtonText="Да"
                  confirmButtonType="danger"
                  cancelButtonType="default"
                  cancelButtonText="Нет"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    class="table__btn"
                    slot="reference"
                    type="danger"
                  />
                </el-popconfirm>
              </el-tooltip>
              <el-tooltip content="Перейти" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-right"
                  circle
                  @click="goItem(scope.row.id, scope.row)"
                />
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>
      </template>

      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <type-edit
      :visible="typeEditModal"
      @close="typeEditModal = false"
    />
  </div>
</template>

<script>
import TypeEdit from '@/components/dialog/procedureType/Edit'

export default {
  name: 'procedure',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      Item: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      selectItem: false,
      addModal: false,
      editModal: false,
      typeEditModal: false
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  components: { TypeEdit },
  methods: {
    loadLogic () {
      this.$api.procedure
        .getList()
        .then((response) => {
          this.tableData = response.data.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })

      // api нет, хардкорд
      const data = { pagination: { total: 1, count: 1, per_page: 1, current_page: 1, total_pages: 1, links: { next: 'http://medtech-backend.test/api/admin/v1/doctor?limit=1&page=1', previous: 'http://medtech-backend.test/api/admin/v1/doctor?limit=1&page=1' } }, data: [{ title: 'Бани', id: 1 }] }
      console.log(data.data)
      this.tableData = data.data

      //
    },
    goItem (id) {
      this.$router.push({
        name: 'cpanel.procedure.list',
        params: { id }
      })
    },
    editItem () {
      this.typeEditModal = !!1
    },
    addItem () {
      this.addModal = !!1
    },
    deleteItem (id, idIndex) {
      this.loading = !!1
      this.$api.procedureType
        .delete(id)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Анкета удалена'
          })
          this.tableData.splice(idIndex, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}
.noty {
  background-color: #ffc9c9;
  margin: 10px 0 2em 0;
  padding: 10px;
  border-radius: 2px;
}
</style>
